<template>
  <div>
    <form class="form" @submit.prevent="updateQuery">
      <input
        v-model="inputQuery"
        type="text"
        id="findContact"
        class="form-control form__input"
        placeholder="Search for a contact's name"
      />
      <button class="form__button" type="submit">Search contacts</button>
    </form>

    <p>Search results for "{{ inputQueryCopy }}"</p>

    <div class="order-grid col-sm-12 col-md-12 col-lg-12">
      <div class="header2">
        <h1 class="title">Team Groups</h1>
        <button type="button" @click="showAddProv">
          <font-awesome-icon icon="plus-circle" />
        </button>
        <button type="button" @click="showProviderGroup">Add Team Group</button>
        <button type="button" @click="GetProviderList">View Team Group</button>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 provcardSec">
        <div class="col-sm-12 col-md-12 col-lg-12 col1">
          <label
            ><input type="text" id="addgroupfield" class="group-inputfield" value="" />Add
            Team Group Name</label
          >
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 col2">
          <div v-for="(provider, index) in allProvs" :key="'addprovlist' + index">
            <div class="providerGroup-listcard col-md-3">
              <div class="npi-checkbox">
                <label
                  ><input
                    v-model="newGroupProvs"
                    type="checkbox"
                    id="provichkbx"
                    :value="provider"
                  />{{ provider.firstname + " " + provider.lastname }}</label
                >
              </div>
              <div class="prov-img col-sm-12 col-md-3">
                <img
                  src="@/assets/images/avatar-male.jpg"
                  id="prov-img"
                  width="40"
                  height="40"
                  title="provider image"
                />
              </div>
              <div class="prov-emailsec col-md-3">
                <p class="names-prov">{{ provider.npinumber }}</p>
                <a href="mailto:provider.email" title="Provider Email Information">{{
                  provider.email
                }}</a>
                <p class="prov-phone">{{ provider.tel }}</p>
              </div>
            </div>
          </div>
          <div v-if="!allContacts.length">No Contacts Available</div>
          <div v-for="(pContacts, index) in allContacts" :key="'addteamlist' + index">
            <div class="providerGroup-listcard col-md-3">
              <div class="npi-checkbox">
                <label
                  ><input
                    v-model="newGroupEmails"
                    type="checkbox"
                    id="provichkbx"
                    :value="pContacts"
                  />{{ pContacts.firstName + " " + pContacts.lastName }}</label
                >
              </div>
              <div class="prov-img col-sm-12 col-md-3">
                <img
                  src="@/assets/images/avatar-male.jpg"
                  id="prov-img"
                  width="40"
                  height="40"
                  title="provider image"
                />
              </div>
              <div class="prov-emailsec col-md-3">
                <a href="mailto:pContacts.email" title="Provider Email Information">{{
                  pContacts.email
                }}</a>
                <p class="prov-phone">{{ pContacts.primaryPhone }}</p>
              </div>
            </div>
          </div>
          <div v-for="(pNurse, index) in allNurses" :key="'addteamlist' + index">
            <div class="providerGroup-listcard col-md-3">
              <div class="npi-checkbox">
                <label
                  ><input
                    v-model="newGroupNurses"
                    type="checkbox"
                    id="provichkbx"
                    :value="pNurse"
                  />
                  {{ pNurse.firstname + " " + pNurse.lastname }}</label
                >
              </div>
              <div class="prov-img col-sm-12 col-md-3">
                <img
                  src="@/assets/images/avatar-male.jpg"
                  id="prov-img"
                  width="40"
                  height="40"
                  title="provider image"
                />
              </div>
              <div class="prov-emailsec col-md-3">
                <a href="mailto:pNurse.email" title="Nurse Email Information">{{
                  pNurse.email
                }}</a>
                <p class="prov-phone">{{ pNurse.primaryphone }}</p>
              </div>
            </div>
          </div>
          <div class="addgroup-sec">
            <button
              type="button"
              class="group-btn col-sm-12 col-md-6 col-lg-6"
              id="addgroupbtn"
              @click="AddProviderGroup()"
            >
              Add Team Group
            </button>
            <button
              type="button"
              class="group-btn col-sm-12 col-md-6 col-lg-6"
              id="exitgroupbtn"
              @click="CloseProviderGroup()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 listGroupSec">
        <div class="card" v-for="(group, index) in groupNumber" :key="'grplist' + index">
          <div class="accordhead">
            <div class="caret">
              <span @click="ShowGroupList(index)" id="accord-caret">+</span>
              <div class="elipsecontainer">
                <div id="elipse" @click="ShowSubNav(index)">...</div>
                <div class="subnavcontainer" :id="'subnav' + index">
                  <div class="sub-nav">
                    <a
                      href="#email"
                      :id="'mergeemail' + index"
                      @click="SendGroupEmail(index)"
                      >Send Group Email
                    </a>
                  </div>
                  <div class="sub-nav">
                    <a
                      href="#textsms"
                      :id="'mergetext' + index"
                      @click="SendGroupText(index)"
                      >Send Group SMS</a
                    >
                  </div>
                  <div class="sub-nav">
                    <a
                      href="#conftextsms"
                      :id="'mergeconftext' + index"
                      @click="GroupConferenceCall(index)"
                      >Conference Call SMS Group</a
                    >
                  </div>
                  <div class="sub-nav">
                    <a
                      href="#deletegrp"
                      :id="'deletegrp' + index"
                      @click="DeleteGroup(index)"
                      >Delete Group</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="grp-name">
              <p :key="index" id="gpname">{{ group.groupname }}</p>
            </div>
          </div>

          <div class="accordionbottom" :id="'accordionbottom' + index">
            <div
              v-for="(provlist, index) in group.providerslist"
              :key="'provlist' + index"
              :id="'provminicard' + index"
              class="providminicard col-sm-12 col-md-12 col-lg-12"
            >
              <div class="col-sm-12 col-md-3 col-lg-3">
                <p id="grprovemail">{{ provlist.email }}</p>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-3">
                <p>{{ provlist.firstname }} {{ provlist.lastname }}</p>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-3">
                <p id="grpnpi">{{ provlist.npi }}</p>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-3">
                <p id="grpphn">{{ provlist.phone }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smsconferencecanvas">
        <div class="container">
          <form id="smsform">
            <label>To:</label
            ><input type="text" required="required" id="smsconferencephone" /><br />
            <textarea id="smsconferencebox" placeholder="Enter Text Message.."> </textarea
            ><br />
            <input
              type="button"
              class="btn btn-danger"
              value="Send Text Message"
              id="sbmttxtconfbtn"
              @click="SendGroupTextMsg"
            />
            <input
              type="button"
              class="btn btn-danger conf-call-btn"
              value="Send Conference Call"
              id="confcallbtn"
              @click="SendGroupConferenceCall"
            />
            <input
              type="button"
              class="btn btn-dark"
              value="Exit & Close"
              id="closeconfcallbtn"
              @click="CloseGroupConferenceCall"
            />
          </form>
        </div>
      </div>
      <div class="groupemailcecanvas">
        <div class="container">
          <form id="emailform">
            <label>To:</label
            ><input type="text" required="required" id="conferenceEmail" /><br />
            <textarea id="emailconferencebox" placeholder="Enter Email Message">
            </textarea
            ><br />
            <input
              type="button"
              class="btn btn-danger"
              value="Send Group Email"
              id="sbmtemailconfbtn"
              @click="SendGroupEmailMsg"
            />
            <input
              type="button"
              class="btn btn-dark"
              value="Cancel"
              id="groupemailcancelbtn"
              @click="CloseGroupEmailMsg"
            />
          </form>
        </div>
      </div>
    </div>

    <template v-if="uContacts.length !== 0 || allProvs.length != 0 || allNurses.length != 0">
      <search-contacts-results
        :contacts="uContacts"
        :keywords="keywords"
      ></search-contacts-results>
      <ul v-if="allProvs.length != 0" class="result-list">
        <li v-for="(provider, index) in allProvs" :key="index">
          <div class="result-item">
            <h2 class="header3 capitalize">
              <span v-if="provider.firstname"
                >{{ provider.firstname.toLowerCase() + " " }}
              </span>
              <span v-if="provider.lastname">{{ provider.lastname.toLowerCase() }}</span>
              <!-- <div class="modifier-container">
                                <button class="modifier-indicator" @click="showMod(index)">...</button>
                                <div class="modifier-dropdown" :id="'modifier-dropdown' + index">
                                    <button class="provbtn edit" @click="showEditProv(provider)">Edit</button>
                                    <button class="provbtn remove"
                                        @click="removeProvider(provider.providerid)">Remove</button>
                                    <button v-if="provider.onTeam != '1'" class="provbtn team"
                                        @click="addProviderTeam(provider, index)">Add to Team</button>
                                    <button v-else class="provbtn team" @click="removeProviderTeam(provider, index)">Remove
                                        from Team</button> -->
              <!-- <button class="provbtn call" @click="callProvider(provider)">Call</button>
                                <button class="provbtn txt" @click="showTextProv(provider)">Text</button>
                                <button class="provbtn email" @click.self="showEmailModule($event,index,provider)">Email</button>-->
              <!-- </div>
                            </div> -->
            </h2>

            <current-provider-bio :provider="provider"></current-provider-bio>
          </div>
        </li>
      </ul>
      <ul v-if="allNurses.length != 0" class="result-list">
        <li v-for="(nurse, index) in allNurses" :key="index">
          <div class="result-item">
            <h2 class="header3 capitalize">
              <span>{{ nurse.firstname.toLowerCase() }} </span>
              <span>{{ nurse.lastname.toLowerCase() }}</span>
            </h2>
            <current-provider-bio :provider="nurse"></current-provider-bio>
          </div>
        </li>
      </ul>
    </template>

    <template v-else>
      <h2>Sorry, we couldn't find anything for "{{ inputQueryCopy }}"</h2>
    </template>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import SearchContactsResults from "./SearchContactsResults";
import CurrentProviderBio from "../providers/CurrentProviderBio";
import { mapGetters } from "vuex";
import { getContacts } from "@/api/userApi";
import $ from "jquery";
import axios from "axios";
export default {
  name: "SearchContacts",
  components: {
    "search-contacts-results": SearchContactsResults,
    "current-provider-bio": CurrentProviderBio,
  },
  data() {
    return {
      allContacts: [],
      uContacts: [],
      allProvs: [],
      allNurses: [],
      newGroupEmails: [],
      newGroupProvs: [],
      newGroupNurses: [],
      grouplist: [],
      groupNumber: [],
      inputQuery: "",
      inputQueryCopy: "", // required. can't use `inputQuery` in the else block because it is reactive',
      keywords: [],
    };
  },
  beforeMount() {
    getContacts().then((c) => {
      this.allContacts = c;
      this.inputQuery = this.$route.query.query;
      this.searchContact(this.$route.query.query);
    });
    this.loadProviders();
    this.loadNurses();
  },
  async mounted() {
    // this.addProviders();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    manager: function () {
      return this.allData.manager;
    },
    relationships: function () {
      return this.allData.relationDescriptions;
    },
  },
  methods: {
    async loadNurses() {
      let content = {
        NursyInfo: {
          API_Meth: "GetPatientNurse",
          accountnumber: this.patient.externId2,
          patientnumber: this.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data) {
            this.allNurses = res.data;
            console.log(this.allNurses);
          }
        });
    },
    async loadProviders() {
      let content = {
        Provider: {
          API_Meth: "GetAllProviders",
          patientid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.provider) {
            this.allProvs = res.data.provider.filter((prov) => prov.onTeam == "1");
          } else {
            this.allProvs = [];
          }
        });
    },
    showAddProv() {
      $(".new-prov-modal").css("display", "flex");
    },
    showProviderGroup() {
      if ($(".provcardSec").css("display") == "flex") {
        $(".provcardSec").slideUp("slow");
      } else {
        //close Provider Group
        $(".provcardSec").slideDown("slow");
        $(".provcardSec").css("display", "flex");
        //autommatically close Provider GFroup if its open
        if ($(".listGroupSec").css("display") == "block") {
          $(".listGroupSec").css("display", "none");
        }
      }
    },
    GetProviderList() {
      if ($(".listGroupSec").css("display") == "block") {
        $(".listGroupSec").slideUp("slow");
      } else if ($(".listGroupSec").css("display") == "none") {
        //$(".listGroupSec").slideDown("slow");
        //lets load in case new groups have been added
        //$(".provcardSec").css("display","none");
        $(".provcardSec").slideUp("slow");
        this.showProviderList();
      } else {
        console.log("do nothing");
      }
    },
    async showProviderList() {
      let content = {
        Provider: {
          API_Meth: "GetProviderGroup",
          accountnumber: this.allData.patient.externId,
          groupowner: this.manager.name,
          grouptype: "team",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.success == "200") {
            //lets bind to listGroupSec div container

            /* $(".listGroupSec").html('');
                         $(".listGroupSec").append(res.data.html);*/
            //lets set the event listener for the elipse buton
            // this.groupNumber.push(res.data.data);

            this.groupNumber = res.data.group;
            this.grouplist = res.data.group.providerslist;

            console.log(this.groupNumber);
            console.log(this.grouplist);
            $(".order-grid").find(".listGroupSec").css("display", "block"); //("slow");
            /* $("#elipse").click(function(event){
                             event.preventDefault();
                             $(".subnavcontainer").css("display","flex");
                            
                         });*/
            /* $(".subnavcontainer").find("#mergetext").click(function(event){
                            event.preventDefault();
                            alert("clicke");
                            $(".smsconferencecanvas").css("display","block");*/
            //now go get the provider that are in the list

            /*let i=0;
                        console.log(event.target.id);
                        console.log($("#"+event.target.id).closest(".card").attr("class"));
                        $("#"+event.target.id).closest(".card").find(".providminicard").each(function(){
                            i++;
                            alert("Hi" +i);
                           this.groupNumber.push($("#grpphn").html());
                           console.log(this.data.groupNumber);
                           console.log($("#grpphn").html());
                           console.log(i +"...Looping"); 
                        });
                        console.log(this.data.groupNumber);
                     });*/
          }
        });
    },
    ShowSubNav(index) {
      if ($("#subnav" + index).css("display") == "flex") {
        $("#subnav" + index).css("display", "none");
      } else {
        $("#subnav" + index).css("display", "flex");
      }
    },
    SendGroupEmail(index) {
      let tempar = "";
      console.log("clicked");
      $("#accordionbottom" + index)
        .find(".providminicard")
        .each(function () {
          console.log("..looping through the mini cards");
          if ($(this).find("#grprovemail").html() != "") {
            //psh into the array
            tempar += $(this).find("#grprovemail").html() + ",";
          } else {
            console.log("didn't record" + $(this).find("#grprovemail").html());
          }
          //lets show case the sms conference canvas
        });
      $(".groupemailcecanvas").css("display", "block");
      $("#conferenceEmail").val(tempar);
      //now close the sub nave
      $("#subnav" + index).css("display", "none");
    },
    async SendGroupEmailMsg() {
      let content = {
        Provider: {
          API_Meth: "SendProviderEmail",
          toemail: $("#conferenceEmail").val(),
          message: $("#emailconferencebox").val(),
          provider: this.manager.name,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "EmailSent") {
            alert(
              "Emails successfully sent to group " + $("#gpname").html() + " members!"
            );
            //now close SMS Canvas
            $(".groupemailcecanvas").css("display", "none");
            // this.groupNumber = res.data.group;
            // this.grouplist = res.data.group.providerslist;
          }
        });
    },
    async SendGroupConferenceCall() {
      let content = {
        Twilio: {
          API_Meth: "SendConferenceText",
          conferencenumbers: $("#smsconferencephone").val(),
          conferencemessage: $("#smsconferencebox").val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.TwilioStatus == "successful") {
            alert(
              "Conference Call successfully sent to group " +
                $("#gpname").html() +
                " members!"
            );
            //now close SMS Canvas
            $("#confcallbtn").css("display", "none");
            $(".smsconferencecanvas").css("display", "none");
            // this.groupNumber = res.data.group;
            // this.grouplist = res.data.group.providerslist;
          }
        });
    },
    CloseGroupEmailMsg() {
      $(".groupemailcecanvas").slideUp("fast");
    },
    CloseGroupConferenceCall() {
      $(".smsconferencecanvas").slideUp("fast");
    },
    CloseProviderGroup() {
      $(".provcardSec").slideUp("slow");
    },
    async SendGroupTextMsg() {
      let content = {
        Twilio: {
          API_Meth: "SendText",
          smsnumber: $("#smsconferencephone").val(),
          smsmessage: $("#smsconferencebox").val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.TwilioStatus == "successful") {
            alert("Text successfully sent to group " + $("#gpname").html() + " members!");
            //now close SMS Canvas
            $(".smsconferencecanvas").css("display", "none");
            // this.groupNumber = res.data.group;
            // this.grouplist = res.data.group.providerslist;
          }
        });
    },
    SendGroupText(index) {
      let tempar = "";

      $("#accordionbottom" + index)
        .find(".providminicard")
        .each(function () {
          console.log("..looping through the mini cards");
          if ($(this).find("#grpphn").html() != "") {
            //psh into the array
            tempar += $(this).find("#grpphn").html() + ",";
          } else {
            console.log("didn't record" + $(this).find("#grpphn").html());
          }
          //lets show case the sms conference canvas
        });
      $(".smsconferencecanvas").css("display", "block");
      $("#smsconferencephone").val(tempar);
      //now close the sub nave
      $("#subnav" + index).css("display", "none");
      $("#smsform").find("#smsconferencebox").val("");
      $("#confcallbtn").css("display", "none");
      $("#sbmttxtconfbtn").css("display", "inline-block");
    },
    GroupConferenceCall(index) {
      let tempar = "";
      console.log("clicked");
      $("#accordionbottom" + index)
        .find(".providminicard")
        .each(function () {
          console.log("..looping through the mini cards");
          if ($(this).find("#grpphn").html() != "") {
            //psh into the array
            tempar += $(this).find("#grpphn").html() + ",";
          } else {
            console.log("didn't record" + $(this).find("#grpphn").html());
          }
          //lets show case the sms conference canvas
        });
      //hide the single text btn
      // $("#sbmttxtconfbtn").css("display","none");
      $(".smsconferencecanvas").css("display", "block");
      $("#smsconferencephone").val(tempar);
      let msg =
        "Please Join The Park Avenue Concierge  Medicine Conference Call. Please be patient as the Conference Call will begin once other participatants join the call. Call the following number: 18556730319";
      $("#smsconferencebox").val(msg);
      // $(this).closest(".subnavcontainer").css("display","none");
      //now close the sub nave
      $("#subnav" + index).css("display", "none");
      $("#sbmttxtconfbtn").css("display", "none");
      $("#confcallbtn").css("display", "inline-block");
    },
    async SendGroupConferenceCall() {
      let content = {
        Twilio: {
          API_Meth: "SendConferenceText",
          conferencenumbers: $("#smsconferencephone").val(),
          conferencemessage: $("#smsconferencebox").val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.TwilioStatus == "successful") {
            alert(
              "Conference Call successfully sent to group " +
                $("#gpname").html() +
                " members!"
            );
            //now close SMS Canvas
            $("#confcallbtn").css("display", "none");
            $(".smsconferencecanvas").css("display", "none");
            // this.groupNumber = res.data.group;
            // this.grouplist = res.data.group.providerslist;
          }
        });
    },
    /* addProviders()
         {
             let data = {};
             
            
            
             this.patientContacts =this.allContacts;
         
         },*/
    async AddProviderGroup() {
      console.log(this.newGroupProvs);
      console.log(this.newGroupEmails);
      console.log("Adding Provider Groupl");
      //lets get the values that we need
      //lets make sure there is a groupName associated with the field and if not send an alert
      if (
        ($("#addgroupfield").val() != "" && this.newGroupProvs != "") ||
        this.newGroupEmails != ""
      ) {
        //ß let npisar =[];
        let mcontent = {
          Provider: {
            API_Meth: "CreateProviderGroup",
            /*npis:$("#provichkbx").each(function(){
                            npisar.push($("#provichkbx").val());
                            console.log(npisar +"Looping..");
                        }),*/
            npis: this.newGroupProvs,
            emails: this.newGroupEmails,
            groupname: $("#addgroupfield").val(), //this.newGroupName
            groupowner: this.manager.name, //this.manager
            accountnumber: this.allData.patient.externId,
            grouptype: "team",
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", mcontent, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);

            if (res.status == "200" && res != "") {
              alert($("#addgroupfield").val() + " " + "has been added successfully");
              //close the Add PRovider UI
              $(".provcardSec").css("display", "none");
              console.log(this.res.message);
            }
          });
      } else {
        alert(
          "Please make sure Group Name has a valid entry and or that you've selected a provider to add to the group."
        );
        $("#addgroupfield").attr("placeholder", "Please enter a valid Group Name");
      }
    },
    ShowGroupList(index) {
      if ($("#accordionbottom" + index).css("display") == "block") {
        $("#accordionbottom" + index).slideUp("slow");
      } else {
        //close the Add Group Section

        $("#accordionbottom" + index).slideDown("slow");
      }
    },
    async DeleteGroup(index) {
      //lets get the group name
      let groupname = $("#deletegrp" + index)
        .closest(".card")
        .find("#gpname")
        .html();
      console.log(groupname);
      let content = {
        Provider: {
          API_Meth: "DeleteProviderGroup",
          accountnumber: this.allData.patient.externId,
          groupowner: this.manager.name,
          groupname: groupname,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == "200" && res.data.message == "Deleted") {
            alert(
              $("#deletegrp" + index)
                .closest(".card")
                .find("#gpname")
                .html() + " has been successfully deleted!"
            );
          }
        });
    },
    searchContact() {
      this.uContacts = [];
      this.inputQueryCopy = this.inputQuery;

      // break down user input to an array of strings, split by white spaces
      this.keywords = stringToArray(this.inputQuery);
      let regexp = new RegExp(this.keywords.join("|"), "i");

      this.allContacts.forEach((c) => {
        if (
          (c.firstName && regexp.test(c.firstName)) ||
          (c.lastName && regexp.test(c.lastName))
        ) {
          this.uContacts.push(c);
        }
      });
    },

    updateQuery() {
      // not redirect, just replace the string
      this.$router.replace({
        path: "search",
        query: { category: "contact", query: this.inputQuery },
      });
      this.searchContact();
    },
  },
};

let stringToArray = (string) => {
  return string.split(/(\s+)/).filter((e) => {
    return e.trim().length > 0;
  });
};
</script>

<style scoped lang="scss">
@import "../../../stylesheets/mixins/flex";

$color-base: #0060ff;
$color-font: #58595b;

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

button {
  border: none;
  cursor: pointer;
  background-color: #2196f3;
  color: #fff;
  padding: 5px 10px;
  font-size: 14px;
}

button:hover {
  background-color: #0060ff;
}

h2 {
  font-size: 1.5em;
  color: $color-font;
  margin-top: 2em;
  text-align: center;
}

p {
  margin-top: 1em;
  font-size: 0.85em;
}

.list {
  margin: 0 auto;
}

.form-control {
  font-size: 0.85em;
}

.form {
  @include flex-box();
  @include flex-wrap(wrap);

  .form__input {
    @include flex(1, 0, 70%);
  }

  .form__button {
    @include flex(1, 0, 20%);
  }
}

header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #0060ff;
}

.title {
  margin-right: 20px;
}

.result-list {
  width: 700px;
}

.result-item {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 2em auto 0;
  text-align: left;
}

.result-item:first-child {
  margin-top: 1em;
}

.header3 {
  text-align: center;
  color: #fff;
  font-size: 1.2em;
  padding: 5px 0;
  background-color: #007bff;
}

.capitalize {
  text-transform: capitalize;
}

.result-item-link {
  display: block;
  text-align: right;
  font-size: 0.85em;
}

ul {
  list-style-type: none;
  margin: 0 auto;
}

.providerGroup-listcard {
  display: flex;
  justify-content: space-evenly;
  border-style: dashed;
  border-width: 1px;
  width: 100%;
}

/*Keyon Add Provider CSS*/
.provcardSec {
  display: none;
  align-items: center;
  position: relative;
  flex-direction: column;
}

.emailcanvas {
  display: none;
}

#cllprov {
  margin-left: 20px;
}

#providetomail {
  margin-left: 30px;
}

#provemailsubject {
  margin-left: 30px;
}

#provid-emailmsg {
  margin-left: 30px;
  margin-top: -10px;
  margin-bottom: 10px;
  width: 400px;
  height: 100px;
}

#sendprovid-emailbtn {
  margin-left: 30px;
}

.emailcanvas .container {
  box-shadow: 1px 1px 9px #5f5852;
  position: absolute;
  background-color: #ffffff;
  width: 855px;
  height: auto; // 710px;
  padding-bottom: 20px;
  margin: 0 auto;
}

.emailcanvas .btn-container {
  padding-bottom: 30px;
}

.emailcanvas label {
  margin-bottom: 20px;
}

#providetomail {
  margin-left: 30px;
}

.emailcanvas ul {
  display: flex;
  margin-top: -64px;
}

.emailcanvas .emailli {
  list-style: none;
  margin-left: 20px;
}

.emailcanvas .emailblock {
  background-color: #aaabac;
  padding: 5px 5px;
  width: auto;
  height: auto;
  margin-left: 12px;
  position: relative;
  top: 17px;
}

.emailcanvas .xout {
  background-color: white;
  cursor: pointer;
}

.mmailbox {
  background-color: #55555512;
  width: 100%;
  position: relative;
  z-index: 3000000000;
  top: -35px;
}

.mmailbox #hiddenmail {
  display: none;
}

.emailcanvas .selectbox {
  margin-top: -10px;
}

.inputvalholder {
  display: none;
  justify-content: flex-start;
}

.listGroupSec {
  display: none;
}

.listGroupSec .card .accordhead {
  display: flex;
  flex-direction: row-reverse;
  border-style: solid;
  border-width: 1px;
  border-color: #606565b0;
}

.listGroupSec .card .caret {
  text-align: right;
  width: 100px;
}

.listGroupSec .card .grp-name {
  width: 100%;
  margin: 0 auto;
}

.listGroupSec .card .grp-name p {
  text-align: center;
}

.listGroupSec .accordionbottom {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-style: solid;
  border-width: 1px;
  border-color: #0433;
  display: flex;
}

.listGroupSec .providminicard {
  display: flex;
  flex-direction: row-reverse;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  flex-direction: row-reverse;
  padding: 11px;
  margin-bottom: 3px;
}

.listGroupSec #accord-caret {
  cursor: pointer;
}

.listGroupSec #accord-caret:hover {
  color: #4553;
}

.listGroupSec .groupcanvas .card {
  display: flex;
  flex-direction: column;
}

.listGroupSec .subnavcontainer {
  display: none;
  flex-direction: column;
  width: 248px;
  margin-left: -153px;
  border-style: ridge;
  padding: 11px;
}

.listGroupSec #elipse {
  cursor: pointer;
}

.listGroupSec .closecanvas {
  display: none;
}

.listGroupSec .creategrpcanvas {
  display: none;
}

.listGroupSec .groupcanvas {
  display: none;
}

.accordionbottom {
  display: none;
}

.smsconferencecanvas {
  display: none;
}

.listGroupSec .accordionbottom {
  display: none;
}

.groupemailcecanvas {
  display: none;
}

#sbmttxtconfbtn {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;
}

#smsconferencebox {
  width: 650px;
  height: 220px;
}

#smsconferencephone {
  width: 425px;
  height: 45px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
}

.smsconferencecanvas .container {
  padding: 10px;
  display: flex;
  text-align: center;
}

.groupemailcecanvas .container {
  padding: 10px 100px;
  display: flex;
  text-align: center;
}

li h2 {
  margin-top: 2%;
}

#emailform {
  border-style: solid;
  border-width: 1px;
  border-color: #003330;
}

#conferenceEmail {
  width: 425px;
  height: 45px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
}

#emailconferencebox {
  width: 650px;
  height: 220px;
}

#sbmtemailconfbtn {
  margin-top: 15px;
  margin-bottom: 15px;
}

.smsconferencecanvas #closeconfcallbtn {
  margin-left: 15px;
}

#groupemailcancelbtn {
  margin-left: 15px;
}

.prvtxtbox {
  height: 42px;
}
</style>
